<template>
  <v-row>
    <v-col cols="12" v-if="loaderRetrieve">
      <v-skeleton-loader type="table" />
      <v-skeleton-loader class="mt-5" type="table" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card class="mb-6">
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Correos electrónicos de clientes</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="transparent">
            <template v-for="(d, i) in customerEmails">
              <v-list-item two-line :key="`item-${i}`">
                <v-list-item-content>
                  <v-list-item-title class="body-2 text--secondary font-weight-medium">{{d.title}}</v-list-item-title>
                  <v-list-item-subtitle class="mt-1">{{d.description}}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-content>
                  <v-btn text color="primary" :ripple="false" @click="selectedCustomerEmail=d, dialogCustomerEmailsPreview=true">Previsualizar</v-btn>
                </v-list-item-content>
                <v-list-item-action>
                  <v-switch v-model="customerEmails[i].active" :width="32" :height="18" hide-details />
                </v-list-item-action>
              </v-list-item>
              <v-divider :key="`divider-${i}`" v-if="i < customerEmails.length - 1" />
            </template>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="patchAccount" :loading="$store.state.accounts.createLoader" color="primary">Guardar</v-btn>
        </v-card-actions>
      </v-card>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Proveedores de correo electrónico</v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Cuenta</th>
                  <th class="text-left">Proveedor</th>
                  <th class="text-left">Verificación</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="emailsDetail.uid">
                  <td>
                    <span class="mr-4">{{emailsDetail.uid}}</span>
                    <v-tooltip right transition="scale-transition" max-width="260">
                      <template v-slot:activator="{on}">
                        <v-chip v-on="on" color="lightBlue" text-color="primary" small>Primario</v-chip>
                      </template>
                      <span>Los correos electrónicos se envían desde {{emailsDetail.uid}}, pero si la conexión falla, se asegura la entrega usando un proveedor de correo electrónico de Piriod.</span>
                    </v-tooltip>
                  </td>
                  <td class="text-uppercase">{{emailsDetail.provider}}</td>
                  <td><v-chip color="lightBlue" text-color="primary" small>Verificado</v-chip></td>
                </tr>
                <tr>
                  <td>invoices@on.piriod.com</td>
                  <td class="text-uppercase">Piriod</td>
                  <td><v-chip color="lightBlue" text-color="primary" small>Verificado</v-chip></td>
                </tr>
                <tr>
                  <td>payments@on.piriod.com</td>
                  <td class="text-uppercase">Piriod</td>
                  <td><v-chip color="lightBlue" text-color="primary" small>Verificado</v-chip></td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <v-divider />
          <v-toolbar class="transparent mt-3" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">{{ emailsDetail.uid ? 'Actualizar' : 'Conectar' }} proveedor de correo electrónico</v-toolbar-title>
          </v-toolbar>
          <v-row aling="center" justify="start" class="mx-0">
            <v-col cols="3">
              <v-hover v-slot:default="{ hover }" open-delay="200">
                <v-card class="card-center" @click="dialogEmailProvider=true" :elevation="hover ? 3 : 1" min-height="180" width="300" :ripple="false">
                  <v-container fluid class="text-center">
                    <img :src="require('@/assets/appAsset-ui-genericEmail.svg')" width="56px">
                    <span :class="`${hover ? 'primary--text' : '' } d-block font-weight-medium mt-6`">Otra cuenta de email</span>
                  </v-container>
                </v-card>
              </v-hover>
            </v-col>
          </v-row>
          <v-divider />
        </v-card-text>
      </v-card>
    </v-col>

    <!-- dialog email -->
    <v-dialog v-model="dialogEmailProvider" width="700" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Conectar otra cuenta de email (SMTP)</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn @click="dialogEmailProvider=false" icon small :ripple="false"><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-list class="v-list-form py-6 px-1 transparent">
            <v-list-item class="py-1">
              <v-list-item-title>Email</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="10">
                  <v-text-field v-model.trim="$v.email.uid.$model" :error="$v.email.uid.$error" background-color="white" outlined required single-line dense  maxlength="254" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Servidor / dominio</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="7">
                  <v-text-field v-model.trim="$v.email.extra_data.host.$model" :error="$v.email.extra_data.host.$error" placeholder="e.g. smtp.gmail.com" background-color="white" outlined required single-line dense maxlength="254" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Puerto</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="3">
                  <v-text-field v-model.trim="$v.email.extra_data.port.$model" :error="$v.email.extra_data.port.$error" placeholder="e.g. 445" background-color="white" outlined required single-line dense maxlength="5" hide-details />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Conexión segura (SSL)</v-list-item-title>
              <v-list-item-subtitle>
                <v-switch class="mt-n4" v-model="email.extra_data.use_ssl" style="position: absolute" />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Contraseña</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="7">
                  <v-text-field class="icon-field" v-model.trim="$v.email.extra_data.password.$model" :error="$v.email.extra_data.password.$error" background-color="white" @click:append="show1 = !show1" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show1 ? '$v.email.extra_data.password.$model' : 'password'" outlined hide-details required single-line dense maxlength="64" autocomplete="new-password" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item class="py-1">
              <v-list-item-title>Contraseña</v-list-item-title>
              <v-list-item-subtitle>
                <v-col cols="7">
                  <v-text-field class="icon-field" v-model="email.extra_data.password2" :error="$v.email.extra_data.password2.$error" background-color="white" @click:append="show = !show" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'" :type="show ? '$v.email.extra_data.password.$model' : 'password'" outlined required single-line dense maxlength="64" :hide-details="$v.email.extra_data.password2.sameAsPassword" persistent-hint hint="La contraseña debe coincidir." autocomplete="new-password" />
                </v-col>
              </v-list-item-subtitle>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn @click="dialogEmailProvider=false, $v.email.$reset()" outlined color="secondary">Cancelar</v-btn>
          <v-btn @click="createEmail" :loading="$store.state.accounts.createLoader" color="primary">Conectar email</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end dialog email -->

    <!-- customer emails preview -->
    <v-dialog v-model="dialogCustomerEmailsPreview" v-if="selectedCustomerEmail" width="800" persistent no-click-animation scrollable>
      <v-card>
        <v-card-title class="pa-0">
          <v-toolbar flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Correo electrónico de {{selectedCustomerEmail.title | lower}}</v-toolbar-title>
            <v-spacer />
            <v-toolbar-items>
              <v-row align="center" justify="center" class="mr-1">
                <v-btn class="ml-3" @click="dialogCustomerEmailsPreview=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
              </v-row>
            </v-toolbar-items>
          </v-toolbar>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0">
          <v-row no-gutters>
            <v-col cols="4" style="border-right: 1px solid #D8E0EA">
              <v-list class="pt-3">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="d-block text--secondary font-weight-medium">Las respuestas se dirigen a</v-list-item-title>
                    <v-list-item-subtitle class="text--primary mt-2">{{account.email}}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item>
                  <v-list-item-content>{{selectedCustomerEmail.description}}</v-list-item-content>
                </v-list-item>
                <v-list-item v-if="selectedCustomerEmail.preview.status === 'succeeded'">
                  <v-list-item-content>Si el pago pertenece a una factura, se muestra el detalle de los productos / servicios cobrados y el desglose de los totales.</v-list-item-content>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="8" class="pa-6">
              <template v-if="selectedCustomerEmail.preview.status === 'succeeded'">
                <reminder-payment-email :template="account.email_template" :color-background="account.color_background" :instance="selectedCustomerEmail.preview.instance" />
              </template>
              <template v-else-if="selectedCustomerEmail.preview.status === 'failed'">
                <reminder-payment-email :template="account.email_template" :color-background="account.color_background" :instance="selectedCustomerEmail.preview.instance" :status="selectedCustomerEmail.preview.status" :message="selectedCustomerEmail.preview.message" />
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end customer emails preview -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, requiredIf, maxLength, numeric, sameAs, email } from 'vuelidate/lib/validators'
import ReminderPaymentEmail from '@/components/reminders/payments/Email'
import GenericViewMixin from '@/mixins/GenericViewMixin'
export default {
  mixins: [
    GenericViewMixin
  ],
  components: {
    ReminderPaymentEmail
  },
  data: () => ({
    customerEmails: [
      {
        title: 'Pago recurrente exitoso',
        description: 'Se envía cuando un pago recurrente es procesado exitosamente.',
        value: 'on_successful_recurring_payment',
        active: false,
        preview: {
          instance: {
            amount: 100.00,
            currency: 'USD',
            payment_date: '2021-01-02',
            source: {
              gateway: {
                flow: 'none',
                usage: 'reusable'
              },
              card: {
                brand: 'Visa',
                last4: '6642'
              }
            }
          },
          status: 'succeeded'
        }
      },
      {
        title: 'Pago recurrente fallido',
        description: 'Se envía cuando un pago recurrente falla. Se informa el motivo al cliente.',
        value: 'on_failed_recurring_payment',
        active: false,
        preview: {
          instance: {
            amount: 119.00,
            currency: 'USD'
          },
          status: 'failed',
          message: 'Nuestro intento de cargar 119.00 USD a tu tarjeta de crédito registrada, Visa que termina en 6642, falló.'
        }
      },
      {
        title: 'Pago único exitoso',
        description: 'Se envía cuando un pago es pagado con éxito a través del portal de pagos.',
        value: 'on_successful_one_time_payment',
        active: false,
        preview: {
          instance: {
            amount: 25600.00,
            currency: 'CLP',
            payment_date: '2021-01-02',
            source: {
              gateway: {
                flow: 'none',
                usage: 'single',
                name: 'Mercado Pago'
              },
              card: {
                brand: 'Visa',
                last4: '6642'
              }
            },
            intent: {
              funding: 'credit'
            }
          },
          status: 'succeeded'
        }
      },
      {
        title: 'Transferencia registrada',
        description: 'Se envía cuando un pago es pagado usando una transferencia.',
        value: 'on_registered_transfer_payment',
        active: false,
        preview: {
          instance: {
            amount: 61000.00,
            currency: 'CLP',
            payment_date: '2021-01-02',
            source: {
              gateway: {
                flow: 'receiver',
                usage: 'single',
                id: 'ach_transfer'
              }
            }
          },
          status: 'succeeded'
        }
      },
      {
        title: 'Pago externo registrado',
        description: 'Se envía cuando un pago es pagado usando un pago externo.',
        value: 'on_registered_offline_payment',
        active: false,
        preview: {
          instance: {
            amount: 225.50,
            currency: 'USD',
            payment_date: '2021-01-02',
            source: {
              gateway: {
                flow: 'receiver',
                usage: 'single',
                id: 'offline_payment'
              },
              offline_payment: {
                method: 'cash'
              }
            }
          },
          status: 'succeeded'
        }
      }
    ],
    dialogCustomerEmailsPreview: false,
    dialogEmailProvider: false,
    email: {
      provider: 'smtp',
      uid: '',
      extra_data: {
        host: '',
        port: '',
        use_ssl: true,
        password: '',
        password2: ''
      }
    },
    loaderRetrieve: false,
    selectedCustomerEmail: null,
    show: false,
    show1: false
  }),
  computed: mapState({
    accountsDetail: state => state.accounts.accountsDetail,
    emailsDetail: state => state.accounts.emailsDetail
  }),
  created () {
    this.loaderRetrieve = true
    Promise.all([
      this.$store.dispatch('accounts/RETRIEVE', {
        resource: 'emails',
        id: this.account.id
      }),
      this.$store.dispatch('accounts/RETRIEVE', {
        resource: 'accounts',
        id: this.account.id
      })
      .then(() => {
        this.customerEmails.forEach((ce, i) => {
          if (this.accountsDetail.customer_emails && this.accountsDetail.customer_emails.includes(ce.value)) {
            this.customerEmails[i].active = true
          }
        })
      })
    ])
    .finally(() => {
      this.loaderRetrieve = false
    })
  },
  methods: {
    patchAccount () {
      const payload = {
        customer_emails: this.customerEmails.filter(ce => ce.active).map(ce => ce.value)
      }
      this.$store.dispatch('accounts/UPDATE', {
        resource: 'accounts',
        payload: payload,
        id: this.account.id
      })
      .then(() => {
        this.$dialog.message.info('La información de la organización se ha actualizado')
      })
      .catch((error) => {
        this.$dialog.message.warning(this.parseErrors(error.response.data))
      })
    },
    createEmail () {
      this.$v.email.$touch()
      if (this.$v.email.$invalid) {
        return false
      }
      delete this.email.password2
      this.$store.dispatch('accounts/CREATE', {
        resource: 'emails',
        payload: this.email
      })
      .then(() => {
        this.$dialog.message.info('El email ha sido conectado con éxito')
        this.dialogEmailProvider = false
      })
      .catch(() => {
        this.$dialog.message.error('No se pudo conectar el email')
      })
    }
  },
  validations: {
    email: {
      uid: {
        required,
        email,
        maxLength: maxLength(254)
      },
      extra_data: {
        host: {
          required
        },
        port: {
          required,
          numeric,
          maxLength: maxLength(254)
        },
        password: {
          required: requiredIf(function () {
            return this.email.provider === 'smtp'
          })
        },
        password2: {
          sameAsPassword: sameAs('password')
        }
      }
    }
  }
}
</script>